var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area row-center"},[_c('img',{attrs:{"src":_vm.$store.state.project.projectInfo.projectImg,"alt":""}}),_c('h1',[_vm._v(_vm._s(_vm.$store.state.project.projectInfo.buildingName))])])}
var staticRenderFns = []

export { render, staticRenderFns }